import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, computed } from 'vue';
  import type { PropType } from 'vue';
  import { onClickOutside } from '@vueuse/core';
  import IconArrowLite from '@/icons/icon-arrow-lite.vue';
  import BaseInputSkeleton from './BaseInputSkeleton.vue';
  import AppInputLabel from './AppInputLabel.vue';
  import AppInputSelectRow from './AppInputSelectRow.vue';
  import AppInputSelectRowEmpty from './AppInputSelectRowEmpty.vue';
  import AppMenuFloat from './AppMenuFloat.vue';
  import AppPopHover from './AppPopHover.vue';
  import { PerfectScrollbar } from 'vue3-perfect-scrollbar';
  import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
  import type { ModelValue } from '@/stores/types';
  import { useI18n } from 'vue-i18n';

  type InputSize = 'normal' | 'lite';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppInputSelect',
  props: {
    label: {
      type: String,
      default: null
    },
    inputColor: {
      type: String
    },
    labelColor: {
      type: String,
      default: null
    },
    modelValue: {
      type: Object as PropType<ModelValue>,
      default: null
    },
    listOptions: {
      type: Object as PropType<ModelValue[]>,
      default: null
    },
    placeholder: {
      type: String
    },
    inputSize: {
      type: String as PropType<InputSize>,
      default: 'normal'
    },
    enableUnselect: {
      type: Boolean,
      default: true
    },
    showSelectCircle: {
      type: Boolean,
      default: true
    },
    popHoverText: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    exclude: {
      type: Number,
      default: null
    },
    eachRowStyle: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(__props, { expose: __expose, emit: emits }) {
  __expose();

const props = __props;

  const { t } = useI18n();
  //eslint-disable-next-line
  
  //eslint-disable-next-line
  

  const { label, labelColor, placeholder, inputSize, listOptions, modelValue, enableUnselect, inputColor } = toRefs(props);

  const showSelectOptions = ref(false);
  const selectOptions = ref(null);
  const buttonSelectOptions = ref(null);

  onClickOutside(selectOptions, () => (showSelectOptions.value = false), { ignore: [buttonSelectOptions, selectOptions] });

  const updateModelValue = (itemSelected: ModelValue) => {
    if (enableUnselect.value && modelValue.value?.id == itemSelected.id) {
      emits('update:modelValue', null);
    } else {
      emits('update:modelValue', itemSelected);
    }
    showSelectOptions.value = false;
  };

  const iconSize = computed(() => {
    return inputSize.value == 'normal' ? 24 : 18;
  });

  const menuFloatTopPosition = computed(() => {
    return inputSize.value == 'normal' ? 'top-12' : 'top-9';
  });

  const menuFloatBottomPosition = computed(() => {
    return inputSize.value == 'normal' ? 'bottom-12' : 'bottom-9';
  });

const __returned__ = { t, emits, props, label, labelColor, placeholder, inputSize, listOptions, modelValue, enableUnselect, inputColor, showSelectOptions, selectOptions, buttonSelectOptions, updateModelValue, iconSize, menuFloatTopPosition, menuFloatBottomPosition, toRefs, ref, computed, get onClickOutside() { return onClickOutside }, IconArrowLite, BaseInputSkeleton, AppInputLabel, AppInputSelectRow, AppInputSelectRowEmpty, AppMenuFloat, AppPopHover, get PerfectScrollbar() { return PerfectScrollbar }, get useI18n() { return useI18n } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})